import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSidebarPeople = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.229 13.648c2.14.02 4.028.254 5.403.87.697.313 1.298.739 1.722 1.318.431.589.646 1.289.642 2.079v.018l-.002.018c-.042.792-.331 1.526-.881 2.065-.554.543-1.314.83-2.185.83H5.515c-.871 0-1.633-.287-2.188-.83-.552-.54-.841-1.275-.879-2.07v-.035c0-.792.217-1.492.648-2.08.426-.58 1.026-1.008 1.723-1.32 1.375-.617 3.26-.847 5.397-.862zm-6.282 4.245c.026.468.191.819.428 1.05.238.233.605.403 1.14.403h9.413c.533 0 .898-.17 1.135-.402.238-.232.404-.585.433-1.056 0-.49-.13-.864-.352-1.165-.23-.315-.594-.598-1.125-.836-1.083-.485-2.713-.718-4.799-.739-2.08.016-3.706.247-4.787.731-.531.238-.895.522-1.127.838-.223.305-.356.681-.359 1.176M10.227 5.094a2.8 2.8 0 1 0 0 5.6 2.8 2.8 0 0 0 0-5.6m-4.3 2.8a4.3 4.3 0 1 1 8.6 0 4.3 4.3 0 0 1-8.6 0M17.264 13.12a.75.75 0 0 1 .888-.58c1.001.21 1.896.555 2.55 1.126.683.596 1.054 1.397 1.049 2.374v.018l-.001.017c-.06 1.102-.66 2.064-1.747 2.44a.75.75 0 0 1-.49-1.417c.418-.145.701-.504.738-1.085-.001-.537-.19-.915-.536-1.217-.38-.331-.99-.604-1.87-.788a.75.75 0 0 1-.58-.888M15.187 5.557a.75.75 0 0 1 .909-.546 3.404 3.404 0 0 1 .267 6.525.75.75 0 1 1-.482-1.42 1.905 1.905 0 0 0-.149-3.65.75.75 0 0 1-.545-.91"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSidebarPeople);
export default ForwardRef;
